import { cloneDeep } from 'lodash';
import { EntityId } from 'src/app/shared/config/entity-config';

export interface DeliveryNoteInput {
    docInfo: DocInfo;
    customerInfo: CustomerInfo;
    items: DeliveryItemInfo[];
}

interface DocInfo {
    // Defaults to the company (same rationale as the manual tax-invoice form:
    // manual documents are usually the company's offline sales). Nullable
    // because the select box has a clear button — the builder path still
    // guards against issuing with no seller picked.
    entityId: EntityId | null;
    invNum: string;
    date: string;
    refNo: string;
    remark: string;
    customTitle: string;
    hideSignatureFields: boolean;
    isSigned: boolean;
}

interface CustomerInfo {
    name: string;
    taxId: string;
    branch: string;
    postCode: string;
    province: string;
    district: string;
    subDistrict: string;
    address1: string;
    fullAddress: string;
    useCustomAddress: boolean;
    customAddress: string;
}

export interface DeliveryItemInfo {
    itemNo: number;
    description: string;
    quantity: number | null;
    quantityName: string;
}

const inputMomentFormat = 'YYYY-MM-DD';

const initialDeliveryNoteInput: DeliveryNoteInput = {
    docInfo: {
        entityId: 'genlogic-co',
        invNum: '',
        date: '',
        refNo: '',
        remark: '',
        customTitle: '',
        hideSignatureFields: false,
        isSigned: true,
    },
    customerInfo: {
        name: '',
        taxId: '',
        branch: '',
        postCode: '',
        province: '',
        district: '',
        subDistrict: '',
        address1: '',
        fullAddress: '',
        useCustomAddress: false,
        customAddress: '',
    },
    items: [],
};

const getInitialDeliveryNoteInput = (): DeliveryNoteInput => {
    return cloneDeep(initialDeliveryNoteInput);
};

export { inputMomentFormat, getInitialDeliveryNoteInput };
